import { useForm } from 'react-hook-form';

import {
  Button,
  Input,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Text,
} from '@chakra-ui/react';
import { useRef, useState } from 'react';
import Container from '../components/Container';

const ForgotPasswordPage = () => {
  const search = new URLSearchParams(window.location.search);
  const [error, setError] = useState(search.has('error'));
  const ref = useRef();

  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = async (data) => {
    setError(false);
    const asd = window.AmazonCognitoAdvancedSecurityData.getData(data.user, '', search.get('client_id'));
    ref.current.asd.value = asd;
    ref.current.submit();
    return true;
  };

  const onHandleSubmit = (ev) => {
    ev.stopPropagation();
    ev.preventDefault();
    handleSubmit(onSubmit)();
  };

  return (
    <Container py="8">
      {/* eslint-disable-next-line max-len */}
      <form ref={ref} onSubmit={onHandleSubmit} action={`${process.env.REACT_APP_BACKEND}/auth/forgotPassword${window.location.search}`} method="POST">
        <Heading className="card-title text-center" mb="2" size="md" fontWeight="normal">
          Forgot your password?
        </Heading>
        <Text fontSize="sm" color="gray.600">Enter your email below and we will send a message to reset your password</Text>
        {error && (
          <Text my="2" fontSize="sm" color="red.500">
            Could not reset password for the account, please contact support or try again
          </Text>
        )}

        <FormControl my="6" isInvalid={errors.email}>
          <FormLabel mb="0.5" fontSize="sm">Email</FormLabel>
          <Input size="sm" type="email" placeholder="Email" {...register('email', { required: true })} />
          <FormErrorMessage>The email address is required</FormErrorMessage>
        </FormControl>

        <input type="hidden" className="form-control" name="asd" />
        <Button colorScheme="blue" type="submit" size="sm" isLoading={isSubmitting} px="10">Reset my password</Button>
      </form>
    </Container>
  );
};

export default ForgotPasswordPage;
